// import { Route } from '@angular/compiler/src/core';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
// import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { MatDialog } from '@angular/material/dialog';
import { HttpRequestService } from 'src/app/common-services/http-request.service';
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';
import { UserInfoService } from 'src/app/common-services/user-info.service';
import { CompanyService } from 'src/app/common-services/Company.service';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { DashboardService } from 'src/app/common-services/dashboard.service';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/common-services/notification.service';
import { ReadOnlyService } from 'src/app/common-services/read-only.service';
import { Observable } from 'rxjs';

import jwt_decode from 'jwt-decode';
import { CompanySwitcherModalComponent } from 'src/app/common-components/company-switcher-modal/company-switcher-modal.component';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
	@Output() toggleSidebar = new EventEmitter<void>();
	hidden = false;
	userAuthinfo: any;
	first: any;
	last: any;
	notifications: any;
	count: any;
	FinalRoute: any;
	pageTitle = 'Dashboard';
	isReadOnly$: Observable<boolean>;

	toggleBadgeVisibility() {
		this.hidden = !this.hidden;
		this.getNotification();
	}

	onToggleSidebar() {
		this.toggleSidebar.emit();
	}
	analyticsObj = {}
	todayDate = new Date();

	constructor(private authuserInfo: UserInfoService, private cdr: ChangeDetectorRef, private router: Router, public dialog: MatDialog, private spinner: NgxSpinnerService, private http: HttpRequestService, private route: Router,
		private companyService: CompanyService,
		private dashboardSvc: DashboardService,
		private location: Location,
		private translate: TranslateService,
		private notificationService: NotificationService,
		public readOnlyService: ReadOnlyService
	) {
		this.isReadOnly$ = this.readOnlyService.isReadOnly$;
	}
	// openDialog() {
	// 	this.dialog.open();
	//   }
	async ngOnInit() {
		if (!localStorage.getItem('menuTitlesSanitized')) {
			localStorage.removeItem('menuTitles');
			localStorage.setItem('menuTitlesSanitized', 'true');
		}

		this.updateTitle(this.router.url);

		this.translate.onLangChange.subscribe(() => {
			this.updateTitle(this.router.url);
		});

		this.notificationService.refreshNotificationCount$.subscribe(() => {
			this.getNotificationCount();
		});

		this.userAuthinfo = this.authuserInfo.userInfo();




		if (this.userAuthinfo) {
			this.analyticsObj = {
				user_id: this.userAuthinfo.user_id,
				analytics_screen_id: 10,
			}

			// this.getNotification();
			this.getNotificationCount();

			this.router.events.subscribe(event => {

				if (event instanceof NavigationStart) {
					// Show loading indicator
				}

				if (event instanceof NavigationEnd) {
					// Hide loading indicator

					// this.getNotification();
					this.getNotificationCount();
					this.updateTitle(event.urlAfterRedirects || event.url);
				}

				if (event instanceof NavigationError) {
					// Hide loading indicator

					// Present error to user

				}
			});





		}


		let userName = this.userAuthinfo.Name.split(" ")


		this.first = userName[0][0];
		if (userName.length == 2) {
			this.last = userName[1][0];
		}

		this.getGcUserList();

		if (this.userAuthinfo?.role?.id == 1) {
			this.getGc(false);
		}

		this.gc_debounce_base();

		this.companyService.refreshCompanyList$.subscribe(() => {
			this.getGcUserList();
			if (this.userAuthinfo?.role?.id == 1) {
				this.getGc(false);
			}
		});

		// this.set_gc_id_header(localStorage.getItem('header_gc_id'));

		// setTimeout(() => {
		// 	this.set_gc_id_header(localStorage.getItem('header_gc_id'));
		// }, 600);
	}

	updateTitle(url: string) {
		const rawSegment = url.split('?')[0].split('#')[0];

		// Ensure leading slash for matching
		const segment = rawSegment.startsWith('/') ? rawSegment : '/' + rawSegment;
		const queryParams = url.split('?')[1] || '';

		// 1. Static Routes first
		if (segment === '/dashboard' || segment === '/') {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.dashboard', {
				'en-US': 'Dashboard',
				'hi-IN': 'डैशबोर्ड',
				'mr-IN': 'डॅशबोर्ड',
				'bn-IN': 'ড্যাশবোর্ড'
			});
			this.cdr.detectChanges();
			return;
		}
		if (segment === '/dashboard/dpr-work-orders') {
			this.pageTitle = this.getHeaderTransliteration('', {
				'en-US': 'Active Work Orders (DPR)',
				'hi-IN': 'एक्टिव वर्क ऑर्डर (DPR)',
				'mr-IN': 'ॲक्टिव्ह वर्क ऑर्डर (डीपीआर)',
				'bn-IN': 'অ্যাক্টিভ ওয়ার্ক অর্ডার (DPR)'
			});
			this.cdr.detectChanges();
			return;
		}
		if (segment === '/notification') {
			this.pageTitle = this.getHeaderTransliteration('notification.notifications', {
				'en-US': 'Notifications',
				'hi-IN': 'नोटिफिकेशन्स',
				'mr-IN': 'नोटिफिकेशन्स',
				'bn-IN': 'নোটিফিকেশনস'
			});
			this.cdr.detectChanges();
			return;
		}
		if (segment === '/import' || segment.startsWith('/import/')) {
			const queryParamsObj = new URLSearchParams(queryParams);
			const moduleName = queryParamsObj.get('module');

			const moduleDisplayMap: { [key: string]: string } = {
				'vendor': 'labourContractor.subContractor',
				'work-order': 'workOrder.workOrder',
				'billing': 'billing.billing',
				'project': 'project.project'
			};
			const importDataText = this.translate.instant('import.importData') || 'Import Data';
			const displayModuleNameKey = moduleName && moduleDisplayMap[moduleName] ? moduleDisplayMap[moduleName] : '';
			const displayModuleName = displayModuleNameKey ? this.translate.instant(displayModuleNameKey) : '';

			this.pageTitle = displayModuleName ? `${importDataText} - ${displayModuleName}` : importDataText;
			this.cdr.detectChanges();
			return;
		}
		if (segment.includes('/profile/help') || segment.includes('/profile/help-details')) {
			this.pageTitle = this.getHeaderTransliteration('help.help', {
				'en-US': 'Help',
				'hi-IN': 'हेल्प',
				'mr-IN': 'हेल्प',
				'bn-IN': 'হেল্প'
			});
			this.cdr.detectChanges();
			return;
		}
		if (segment.includes('/profile/contact-us')) {
			this.pageTitle = this.getHeaderTransliteration('contactUs.contactUs', {
				'en-US': 'Contact Us',
				'hi-IN': 'कॉन्टैक्ट अस',
				'mr-IN': 'कॉन्ट्रॅक्ट अस',
				'bn-IN': 'কনট্যাক্ট আস'
			});
			this.cdr.detectChanges();
			return;
		}
		if (segment.includes('/profile/my-profile')) {
			this.pageTitle = this.getHeaderTransliteration('myProfile.profile', {
				'en-US': 'Profile',
				'hi-IN': 'प्रोफ़ाइल',
				'mr-IN': 'प्रोफाईल',
				'bn-IN': 'প্রোফাইল'
			});
			this.cdr.detectChanges();
			return;
		}
		if (segment.includes('/profile/terms-and-service')) {
			this.pageTitle = this.getHeaderTransliteration('terms.termsAndConditions', {
				'en-US': 'Terms and Conditions',
				'hi-IN': 'टर्म्स एंड कंडीशंस',
				'mr-IN': 'टर्म्स अँड सर्व्हिस',
				'bn-IN': 'টার্মস অ্যান্ড কন্ডিশনস'
			});
			this.cdr.detectChanges();
			return;
		}
		if (segment.includes('/profile/privacy-policy')) {
			this.pageTitle = this.getHeaderTransliteration('privacyPolicy.privacyPolicy', {
				'en-US': 'Privacy Policy',
				'hi-IN': 'प्रायवेसी पॉलिसी',
				'mr-IN': 'प्रायव्हसी पॉलिसी',
				'bn-IN': 'প্রাইভেসি পলিসি'
			});
			this.cdr.detectChanges();
			return;
		}
		if (segment.includes('company-profile') ||
			segment.includes('/profile/sub-contractor') ||
			segment.includes('/profile/sub contractor') ||
			segment.includes('/profile/general-contractor') ||
			segment.includes('/profile/general contractor') ||
			segment.includes('/profile/gc-profile') ||
			segment.includes('/profile/lc-profile') ||
			segment === '/general-contractor' ||
			segment === '/sub-contractor') {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.companyProfile', {
				'en-US': 'Company Profile',
				'hi-IN': 'कंपनी प्रोफ़ाइल',
				'mr-IN': 'कंपनी प्रोफाइल',
				'bn-IN': 'কোম্পানি প্রোফাইল'
			});
			this.cdr.detectChanges();
			return;
		}
		if (segment.startsWith('/profile') &&
			!segment.includes('/profile/sub-contractor') &&
			!segment.includes('/profile/sub contractor') &&
			!segment.includes('/profile/general-contractor') &&
			!segment.includes('/profile/general contractor') &&
			!segment.includes('/profile/gc-profile') &&
			!segment.includes('/profile/lc-profile')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.settings', {
				'en-US': 'Settings',
				'hi-IN': 'सेटिंग्स',
				'mr-IN': 'सेटिंग्ज',
				'bn-IN': 'সেটিংস'
			});
			this.cdr.detectChanges();
			return;
		}
		if (segment.startsWith('/reports')) {
			if (segment.includes('/reports/summary-dlr-tradewise')) {
				this.pageTitle = this.getHeaderTransliteration('leftMenu.reportSummaryTradewise', {
					'en-US': 'Summary DLR Tradewise',
					'hi-IN': 'समरी डीएलआर ट्रेडवाइज',
					'mr-IN': 'समरी डीएलआर ट्रेडवाइज',
					'bn-IN': 'সামারি ডিএলআর ট্রেডওয়াইজ'
				});
			} else if (segment.includes('/reports/summary-dlr-vendorwise')) {
				this.pageTitle = this.getHeaderTransliteration('leftMenu.reportSummaryVendorwise', {
					'en-US': 'Summary DLR Vendorwise',
					'hi-IN': 'समरी डीएलआर वेंडरवाइज',
					'mr-IN': 'समरी डीएलआर वेंडरवाइज',
					'bn-IN': 'সামারি ডিএলআর ভেন্ডরওয়াইজ'
				});
			} else if (segment.includes('/reports/sub-contractor-performance')) {
				this.pageTitle = this.getHeaderTransliteration('leftMenu.reportSubContractorPerformance', {
					'en-US': 'Sub Contractor Performance',
					'hi-IN': 'सब कांट्रेक्टर परफॉरमेंस',
					'mr-IN': 'सबकॉन्ट्रॅक्टर परफॉर्मन्स',
					'bn-IN': 'সাব কন্ট্রাক্টর পারফরম্যান্স'
				});
			} else {
				this.pageTitle = this.getHeaderTransliteration('leftMenu.reports', {
					'en-US': 'Reports',
					'hi-IN': 'रिपोर्ट्स',
					'mr-IN': 'रिपोर्ट्स',
					'bn-IN': 'রিপোর্টস'
				});
			}
			this.cdr.detectChanges();
			return;
		}
		if (segment.startsWith('/analytics')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.analytics', {
				'en-US': 'Analytics',
				'hi-IN': 'एनालिटिक्स',
				'mr-IN': 'ॲनालिटिक्स',
				'bn-IN': 'অ্যানালিটিক্স'
			});
			this.cdr.detectChanges();
			return;
		}
		if (segment.startsWith('/admin')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.administration', {
				'en-US': 'Administration',
				'hi-IN': 'एडमिनिस्ट्रेशन',
				'mr-IN': 'ॲडमिनिस्ट्रेशन',
				'bn-IN': 'অ্যাডমিনিস্ট্রেশন'
			});
			this.cdr.detectChanges();
			return;
		}

		// 2. Split URL path into clean segments
		const pathSegments = segment.split('/').filter(s => s.length > 0);

		// 3. Check for /dpr routes
		if (pathSegments[0] === 'dpr' && pathSegments.length >= 2) {
			const subKey = pathSegments[1];

			if (subKey === 'dashboard') {
				this.pageTitle = this.getHeaderTransliteration('leftMenu.dprDashboard', {
					'en-US': 'DPR Dashboard',
					'hi-IN': 'डीपीआर डैशबोर्ड',
					'mr-IN': 'डीपीआर डॅशबोर्ड',
					'bn-IN': 'ডিপিআর ড্যাশবোর্ড'
				});
				this.cdr.detectChanges();
				return;
			}

			if (subKey === 'daily-entry') {
				const lang = localStorage.getItem('lang') || 'en-US';
				const baseDict: Record<string, string> = {
					'en-US': 'Daily Entry',
					'hi-IN': 'डेली एंट्री',
					'mr-IN': 'डेली एंट्री',
					'bn-IN': 'ডেইলি এন্ট্রি'
				};
				const baseTitle = baseDict[lang] || 'Daily Entry';
				const actionVal = this.determineAction(pathSegments, queryParams);
				const actionName = this.getActionTranslation(actionVal);
				this.pageTitle = actionName ? `${actionName} ${baseTitle}` : baseTitle;
				this.cdr.detectChanges();
				return;
			}

			if (subKey === 'monthly-plan') {
				const lang = localStorage.getItem('lang') || 'en-US';
				const baseDict: Record<string, string> = {
					'en-US': 'Monthly Plan',
					'hi-IN': 'मंथली प्लान',
					'mr-IN': 'मंथली प्लॅन',
					'bn-IN': 'মন্থলি প্ল্যান'
				};
				const baseTitle = baseDict[lang] || 'Monthly Plan';
				const actionVal = this.determineAction(pathSegments, queryParams);
				const actionName = this.getActionTranslation(actionVal);
				this.pageTitle = actionName ? `${actionName} ${baseTitle}` : baseTitle;
				this.cdr.detectChanges();
				return;
			}
		}

		// 3b. Check for /master routes
		if (pathSegments[0] === 'master' && pathSegments.length >= 2) {
			const moduleKey = pathSegments[1];

			const MASTER_MODULES: Record<string, string> = {
				'specialisation': 'leftMenu.specialization',
				'activity': 'leftMenu.activity',
				'sub-activity': 'leftMenu.subActivity',
				'transport-arrangement': 'leftMenu.transportArrangement',
				'kharchi-credit-period': 'leftMenu.kharchiCreditPeriod',
				'ra-bill-credit-period': 'leftMenu.rabillCreditPeriod',
				'type-of-roads': 'leftMenu.typeOfRoad',
				'function-of-road': 'leftMenu.functionOfRoad',
				'type-of-work': 'leftMenu.typeOfWork',
				'brand-make': 'leftMenu.brandMake',
				'categorization': 'leftMenu.categorization',
				'material-category': 'leftMenu.materialCategory',
				'material-sub-category': 'leftMenu.materialSubCategory',

				'Supply-status': 'leftMenu.supplyStatus',
				'Requistion-status': 'leftMenu.requistionStatus',
				'project-status': 'leftMenu.projectStatus',
				'rcc-sub-structure': 'leftMenu.rccSubStructure',
				'rcc-super-structure': 'leftMenu.rccSuperStructuree',
				'block-work': 'leftMenu.blockWork',
				'internal-plaster': 'leftMenu.internalPlasterr'
			};

			const transKey = MASTER_MODULES[moduleKey];
			const displayName = transKey ? this.translate.instant(transKey) : this.toTitleCase(moduleKey);
			const actionVal = this.determineAction(pathSegments, queryParams);
			const actionName = this.getActionTranslation(actionVal);
			this.pageTitle = actionName ? `${actionName} ${displayName}` : displayName;
			this.cdr.detectChanges();
			return;
		}

		// 4. Check for /users routes
		if (pathSegments[0] === 'users' && pathSegments.length >= 2) {
			const moduleKey = pathSegments[1];
			const USERS_MODULES: Record<string, string> = {
				'back-office': 'leftMenu.captechUser',
				'general-contractor': 'leftMenu.generalContractorUser',
				'sub-contractor': 'leftMenu.subContractorUser',
				'procurement': 'leftMenu.procurementUser',
				'role': 'leftMenu.role',
				'users': 'leftMenu.users'
			};

			const transKey = USERS_MODULES[moduleKey];
			const displayName = transKey ? this.translate.instant(transKey) : this.toTitleCase(moduleKey);
			const actionVal = this.determineAction(pathSegments, queryParams);
			const actionName = this.getActionTranslation(actionVal);
			this.pageTitle = actionName ? `${actionName} ${displayName}` : displayName;
			this.cdr.detectChanges();
			return;
		}

		// 5. Check for Root modules (requisition, supply, project, sub-contractor, general-contractor, supplier, bulk-notification)
		if (pathSegments.length >= 1) {
			const moduleKey = pathSegments[0];

			// Custom handling for requisition connect
			if (moduleKey === 'requisition' && pathSegments.includes('connect')) {
				const baseTitle = this.translate.instant('leftMenu.requisition') || 'Requisition';
				const action = this.getActionTranslation('Connect');
				this.pageTitle = `Connect`;
				this.cdr.detectChanges();
				return;
			}

			// Custom handling for upcoming projects
			if (moduleKey === 'project' && pathSegments.includes('upcoming-projects')) {
				const actionVal = this.determineAction(pathSegments, queryParams);
				const actionName = this.getActionTranslation(actionVal);
				const lang = localStorage.getItem('lang') || 'en-US';
				const dict: Record<string, string> = {
					'en-US': 'Upcoming Project',
					'hi-IN': 'अपकमिंग प्रोजेक्ट',
					'mr-IN': 'अपकमिंग प्रोजेक्ट',
					'bn-IN': 'আপকামিং প্রজেক্ট'
				};
				const displayName = dict[lang] || 'Upcoming Project';
				this.pageTitle = actionName ? `${actionName} ${displayName}` : displayName;
				this.cdr.detectChanges();
				return;
			}

			// // Custom handling for sub-contractor view profile
			// if (moduleKey === 'profile' && (pathSegments.includes('profile') && pathSegments.includes('sub-contractor'))) {
			// 	const lang = localStorage.getItem('lang') || 'en-US';
			// 	const dict: Record<string, string> = {
			// 		'en-US': 'Sub Contractor Profile',
			// 		'hi-IN': 'सब कांट्रेक्टर प्रोफ़ाइल',
			// 		'mr-IN': 'सब कांट्रेक्टर प्रोफ़ाइल'
			// 	};
			// 	this.pageTitle = dict[lang] || 'Sub Contractor Profile';
			// 	this.cdr.detectChanges();
			// 	return;
			// }
			// Custom handling for project view profile
			if (moduleKey === 'project' && pathSegments.includes('view')) {
				const lang = localStorage.getItem('lang') || 'en-US';
				const dict: Record<string, string> = {
					'en-US': 'Project Profile',
					'hi-IN': 'प्रोजेक्ट प्रोफ़ाइल',
					'mr-IN': 'प्रोजेक्ट प्रोफाइल',
					'bn-IN': 'প্রজেক্ট প্রোফাইল'
				};
				this.pageTitle = dict[lang] || 'Project Profile';
				this.cdr.detectChanges();
				return;
			}

			// Custom handling for sub-contractor view profile
			if (moduleKey === 'sub-contractor' && pathSegments.includes('view')) {
				const lang = localStorage.getItem('lang') || 'en-US';
				const dict: Record<string, string> = {
					'en-US': 'Sub Contractor View',
					'hi-IN': 'सब कांट्रेक्टर व्यू',
					'mr-IN': 'सब कांट्रेक्टर व्यू',
					'bn-IN': 'সাব কন্ট্রাক্টর ভিউ'
				};
				this.pageTitle = dict[lang] || 'Sub Contractor View';
				this.cdr.detectChanges();
				return;
			}

			const ROOT_MODULES: Record<string, string> = {
				'requisition': 'leftMenu.requisition',
				'supply': 'leftMenu.supply',
				'project': 'leftMenu.project',
				'sub-contractor': 'leftMenu.subContractor',
				'general-contractor': 'leftMenu.generalContractor',
				'supplier': 'leftMenu.supplier',
				'bulk-notification': 'leftMenu.bulkNotification',
				'work-order': 'leftMenu.workOrder',
				'work-order-rating': 'leftMenu.workOrderRating',
				'bill': 'leftMenu.bill',
				'service-request-wo': 'leftMenu.serviceRequestWorkOrder',
				'inward-billing': 'leftMenu.inwardBilling',
			};

			const transKey = ROOT_MODULES[moduleKey];
			if (transKey) {
				const displayName = this.translate.instant(transKey);
				const actionVal = this.determineAction(pathSegments, queryParams);
				const actionName = this.getActionTranslation(actionVal);
				this.pageTitle = actionName ? `${actionName} ${displayName}` : displayName;
				this.cdr.detectChanges();
				return;
			}
		}

		// 6. Attempt to read specific title from our dynamically saved menu map
		const menuTitles = JSON.parse(localStorage.getItem('menuTitles') || '{}');
		if (menuTitles[segment]) {
			this.pageTitle = menuTitles[segment];
			this.cdr.detectChanges();
			return;
		}

		// 7. Fallbacks
		if (segment.includes('/sub-contractor')) {
			const displayName = this.translate.instant('leftMenu.subContractor') || 'Sub Contractor';
			this.pageTitle = displayName;
		} else if (segment.includes('/general-contractor')) {
			const displayName = this.translate.instant('leftMenu.generalContractor') || 'General Contractor';
			this.pageTitle = displayName;
		} else if (segment.includes('/supplier')) {
			const displayName = this.translate.instant('leftMenu.supplier') || 'Supplier';
			this.pageTitle = displayName;
		} else if (segment.includes('/supply/new')) {
			const actionName = this.getActionTranslation('New');
			const displayName = this.translate.instant('leftMenu.supply') || 'Supply';
			this.pageTitle = `${actionName} ${displayName}`;
		} else if (segment.includes('/supply/edit')) {
			const actionName = this.getActionTranslation('Update');
			const displayName = this.translate.instant('leftMenu.supply') || 'Supply';
			this.pageTitle = `${actionName} ${displayName}`;
		} else if (segment.includes('/supply')) {
			const displayName = this.translate.instant('leftMenu.supply') || 'Supply';
			this.pageTitle = displayName;
		} else if (url.includes('project=update')) {
			const actionName = this.getActionTranslation('Update');
			const displayName = this.translate.instant('leftMenu.project') || 'Project';
			this.pageTitle = `${actionName} ${displayName}`;
		} else if (segment.includes('/project')) {
			const displayName = this.translate.instant('leftMenu.project') || 'Project';
			this.pageTitle = displayName;
		} else if (segment.includes('/requisition/new')) {
			const actionName = this.getActionTranslation('New');
			const displayName = this.translate.instant('leftMenu.requisition') || 'Requisition';
			this.pageTitle = `${actionName} ${displayName}`;
		} else if (segment.includes('/requisition/edit')) {
			const actionName = this.getActionTranslation('Update');
			const displayName = this.translate.instant('leftMenu.requisition') || 'Requisition';
			this.pageTitle = `${actionName} ${displayName}`;
		} else if (segment.includes('/requisition/search')) {
			const actionName = this.getActionTranslation('Search');
			const displayName = this.translate.instant('leftMenu.requisition') || 'Requisition';
			this.pageTitle = `${actionName} ${displayName}`;
		} else if (segment.includes('/requisition')) {
			const displayName = this.translate.instant('leftMenu.requisition') || 'Requisition';
			this.pageTitle = displayName;
		} else if (segment.includes('/bulk-notification')) {
			const displayName = this.translate.instant('leftMenu.bulkNotification') || 'Bulk Notification';
			this.pageTitle = displayName;
		} else if (segment.includes('/role')) {
			const displayName = this.translate.instant('leftMenu.role') || 'Role';
			this.pageTitle = displayName;
		} else if (segment.includes('/users')) {
			const displayName = this.translate.instant('leftMenu.users') || 'Users';
			this.pageTitle = displayName;
		} else if (segment.includes('/profile/help') || segment.includes('/profile/help-details')) {
			this.pageTitle = this.getHeaderTransliteration('help.help', { 'en-US': 'Help', 'hi-IN': 'हेल्प', 'mr-IN': 'हेल्प', 'bn-IN': 'হেল্প' });
		} else if (segment.includes('/profile/contact-us')) {
			this.pageTitle = this.getHeaderTransliteration('contactUs.contactUs', { 'en-US': 'Contact Us', 'hi-IN': 'कॉन्टैक्ट अस', 'mr-IN': 'कॉन्ट्रॅक्ट अस', 'bn-IN': 'কনট্যাক্ট আস' });
		} else if (segment.includes('/profile/my-profile')) {
			this.pageTitle = this.getHeaderTransliteration('myProfile.profile', { 'en-US': 'Profile', 'hi-IN': 'प्रोफ़ाइल', 'mr-IN': 'प्रोफाईल', 'bn-IN': 'প্রোফাইল' });
		} else if (segment.includes('/profile/terms-and-service')) {
			this.pageTitle = this.getHeaderTransliteration('terms.termsAndConditions', { 'en-US': 'Terms and Conditions', 'hi-IN': 'टर्म्स एंड कंडीशंस', 'mr-IN': 'टर्म्स अँड सर्व्हिस', 'bn-IN': 'টার্মস অ্যান্ড কন্ডিশনস' });
		} else if (segment.includes('/profile/privacy-policy')) {
			this.pageTitle = this.getHeaderTransliteration('privacyPolicy.privacyPolicy', { 'en-US': 'Privacy Policy', 'hi-IN': 'प्रायवेसी पॉलिसी', 'mr-IN': 'प्रायव्हसी पॉलिसी', 'bn-IN': 'প্রাইভেসি পলিসি' });
		} else if (segment.includes('/profile')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.settings', { 'en-US': 'Settings', 'hi-IN': 'सेटिंग्स', 'mr-IN': 'सेटिंग्ज', 'bn-IN': 'সেটিংস' });
		} else if (segment.includes('/reports/summary-dlr-tradewise')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.reportSummaryTradewise', { 'en-US': 'Summary DLR Tradewise', 'hi-IN': 'समरी डीएलआर ट्रेडवाइज', 'mr-IN': 'समरी डीएलआर ट्रेडवाइज', 'bn-IN': 'সামারি ডিএলআর ট্রেডওয়াইজ' });
		} else if (segment.includes('/reports/summary-dlr-vendorwise')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.reportSummaryVendorwise', { 'en-US': 'Summary DLR Vendorwise', 'hi-IN': 'समरी डीएलआर वेंडरवाइज', 'mr-IN': 'समरी डीएलआर वेंडरवाइज', 'bn-IN': 'সামারি ডিএলআর ভেন্ডরওয়াইজ' });
		} else if (segment.includes('/reports/sub-contractor-performance')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.reportSubContractorPerformance', { 'en-US': 'Sub Contractor Performance', 'hi-IN': 'सब कांट्रेक्टर परफॉरमेंस', 'mr-IN': 'सबकॉन्ट्रॅक्टर परफॉर्मन्स', 'bn-IN': 'সাব কন্ট্রাক্টর পারফরম্যান্স' });
		} else if (segment.includes('/reports')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.reports', { 'en-US': 'Reports', 'hi-IN': 'रिपोर्ट्स', 'mr-IN': 'रिपोर्ट्स', 'bn-IN': 'রিপোর্টস' });
		} else if (segment.includes('/analytics')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.analytics', { 'en-US': 'Analytics', 'hi-IN': 'एनालिटिक्स', 'mr-IN': 'ॲनालिटिक्स', 'bn-IN': 'অ্যানালিটিক্স' });
		} else if (segment.includes('/admin')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.administration', { 'en-US': 'Administration', 'hi-IN': 'एडमिनिस्ट्रेशन', 'mr-IN': 'ॲडमिनिस्ट्रेशन', 'bn-IN': 'অ্যাডমিনিস্ট্রেশন' });
		} else if (segment.includes('/bill/list')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.bill', { 'en-US': 'Bill', 'hi-IN': 'बिल', 'mr-IN': 'बिल', 'bn-IN': 'বিল' });
		} else if (segment.includes('/bill/')) {
			const actionName = this.getActionTranslation('View');
			const displayName = this.getHeaderTransliteration('leftMenu.bill', { 'en-US': 'Bill', 'hi-IN': 'बिल', 'mr-IN': 'बिल', 'bn-IN': 'বিল' });
			this.pageTitle = `${displayName} Details`;
		} else if (segment.includes('/master')) {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.master', { 'en-US': 'Master', 'hi-IN': 'मास्टर्स', 'mr-IN': 'मास्टर्स', 'bn-IN': 'মাস্টার্স' });
		} else {
			this.pageTitle = this.getHeaderTransliteration('leftMenu.dashboard', { 'en-US': 'Dashboard', 'hi-IN': 'डैशबोर्ड', 'mr-IN': 'डॅशबोर्ड', 'bn-IN': 'ড্যাশবোর্ড' });
		}
		this.cdr.detectChanges();
	}

	private getHeaderTransliteration(key: string, dict: Record<string, string>): string {
		const lang = localStorage.getItem('lang') || 'en-US';
		if (key) {
			const translated = this.translate.instant(key);
			if (translated && translated !== key) {
				return translated;
			}
		}
		return dict[lang] || dict['en-US'] || '';
	}

	private toTitleCase(str: string): string {
		return str
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	}

	private getActionTranslation(action: string): string {
		if (action === 'List') {
			return '';
		}
		const lang = localStorage.getItem('lang') || 'en-US';
		const dict: Record<string, Record<string, string>> = {
			'en-US': { 'List': '', 'New': 'Add', 'Update': 'Edit', 'View': 'View', 'Connect': 'Connect', 'Search': 'Search' },
			'hi-IN': { 'List': '', 'New': 'ऐड', 'Update': 'एडिट', 'View': 'व्यू', 'Connect': 'कनेक्ट', 'Search': 'सर्च' },
			'mr-IN': { 'List': '', 'New': 'ऍड', 'Update': 'एडिट', 'View': 'व्ह्यू', 'Connect': 'कनेक्ट', 'Search': 'सर्च' },
			'bn-IN': { 'List': '', 'New': 'অ্যাড', 'Update': 'এডিট', 'View': 'ভিউ', 'Connect': 'কানেক্ট', 'Search': 'সার্চ' }
		};
		return dict[lang]?.[action] || action;
	}

	private determineAction(pathSegments: string[], queryParams: string): string {
		if (queryParams.includes('view=true')) {
			return 'View';
		}
		if (pathSegments.includes('list')) {
			return 'List';
		}
		if (pathSegments.includes('new') || pathSegments.includes('add') || pathSegments.includes('create')) {
			return 'New';
		}
		if (pathSegments.includes('edit') || pathSegments.includes('update')) {
			return 'Update';
		}
		if (pathSegments.includes('search')) {
			return 'Search';
		}

		const lastSegment = pathSegments[pathSegments.length - 1];
		const staticKeywords = ['filter', 'connect', 'dashboard', 'notification', 'gc-report', 'altius', 'youcon', 'gc', 'lc', 'sprint', 'bo', 'whatsapp', 'gcdump', 'lcdump', 'inapp'];
		if (staticKeywords.includes(lastSegment.toLowerCase())) {
			return 'List';
		}

		if (pathSegments.length === 1) {
			return 'List';
		}

		if (pathSegments.length === 2 && ['master', 'users', 'profile', 'reports'].includes(pathSegments[0].toLowerCase())) {
			return 'List';
		}

		return 'Update';
	}

	activatedRoute(url) {
		return this.router.url.split('/')[1] == url
	}

	get isListPage(): boolean {
		const url = this.router.url.split('?')[0].split('#')[0];
		if (url.endsWith('/list')) return true;
		if (url === '/notification' || url === '/dashboard') return true;
		return false;
	}

	get isEditMode(): boolean {
		const url = this.router.url.split('?')[0].split('#')[0];
		const pathSegments = url.split('/').filter(s => s.length > 0);

		// Static non-edit routes
		if (url === '/dashboard' || url === '/notification' || url === '/') {
			return false;
		}

		if (pathSegments.length > 0) {
			const lastSegment = pathSegments[pathSegments.length - 1].toLowerCase();

			// If URL ends with '-list' or '/list', it's definitely not edit mode
			if (lastSegment.endsWith('-list') || lastSegment === 'list') {
				return false;
			}

			// Profile non-CRUD pages
			if (url.startsWith('/profile') && !url.includes('/sub-contractor') && !url.includes('/general-contractor')) {
				return false;
			}

			// If URL contains '/new', '/edit', '/view', '/update', '/create' anywhere
			const editKeywords = ['new', 'edit', 'view', 'update', 'create'];
			if (pathSegments.some(seg => editKeywords.includes(seg.toLowerCase()))) {
				return true;
			}

			// Known non-edit keywords
			const staticKeywords = ['filter', 'connect', 'dashboard', 'notification', 'gc-report', 'altius', 'youcon', 'gc', 'lc', 'sprint', 'bo', 'whatsapp', 'gcdump', 'lcdump', 'inapp'];
			if (staticKeywords.includes(lastSegment)) {
				return false;
			}

			// Normalize url for case-insensitive and underscore/hyphen-neutral comparison
			const normalizedUrl = url.toLowerCase().replace(/_/g, '-');

			// If we are under any known CRUD modules and the last segment is not a static keyword, it is edit/new mode
			const crudModules = [
				'master', 'users', 'requisition', 'supply', 'project',
				'sub-contractor', 'general-contractor', 'supplier', 'bulk-notification',
				'summary-dlr-tradewise', 'summary-dlr-vendorwise', 'sub-contractor-performance'
			];
			if (crudModules.some(module => normalizedUrl.includes('/' + module))) {
				return true;
			}
		}

		return false;
	}

	goBack() {
		let rawUrl = this.router.url;
		let url = rawUrl.split('?')[0].split('#')[0];

		let redirectFromObj = JSON.parse(sessionStorage.getItem('redirectFrom')) || {};
		let redirectFrom = redirectFromObj.redirectFrom || sessionStorage.getItem('lastRedirectFrom');

		if (redirectFrom) {
			sessionStorage.removeItem('redirectFrom');
			sessionStorage.removeItem('lastRedirectFrom');
			if (redirectFrom === 'supplyList') {
				sessionStorage.setItem('fromPageParam', JSON.stringify({ fromPage: 'Supply-back' }));
				this.location.back();
				return;
			} else if (redirectFrom === 'requisitionSearch') {
				sessionStorage.setItem('fromPageParam', JSON.stringify({ fromPage: 'RequisitionSearch-back' }));
				this.location.back();
				return;
			} else if (redirectFrom === 'requisitionList') {
				sessionStorage.setItem('fromPageParam', JSON.stringify({ fromPage: 'Requisition-back' }));
				this.location.back();
				return;
			} else if (redirectFrom === 'supplySearch') {
				sessionStorage.setItem('fromPageParam', JSON.stringify({ fromPage: 'SupplySearch-back' }));
				this.location.back();
				return;
			}
		}

		if (rawUrl.includes('supplyId=')) {
			let passQueryParam = { fromPage: 'SupplySearch-back' };
			sessionStorage.setItem('fromPageParam', JSON.stringify(passQueryParam));
			this.location.back();
			return;
		} else if (rawUrl.includes('requisitionId=')) {
			let passQueryParam = { fromPage: 'RequisitionSearch-back' };
			sessionStorage.setItem('fromPageParam', JSON.stringify(passQueryParam));
			this.location.back();
			return;
		}

		this.location.back();
	}

	//logout functionality
	logout() {


		this.http.request('post', '/analytics/user-analytics/', this.analyticsObj).subscribe(res => {

		})


		const token = localStorage.getItem('token');
		this.http.request('post', '/user/log-out/', { "user_id": this.userAuthinfo.user_id, token: token }).subscribe(res => {

			localStorage.clear();

			this.route.navigateByUrl('/auth');


		}, err => {
			console.log(err);
			localStorage.clear();

			this.route.navigateByUrl('/auth');
		})
	}

	getNotification() {
		this.http.request('get', '/notification/get-in-app-notification/?user_id=' + this.userAuthinfo['user_id'], null).subscribe(res => {
			let data = res.data.results;
			this.notifications = data

			if (this.notifications.length > 0) {
				this.count = this.notifications[0].pending_count;
				this.cdr.detectChanges();
			}

		}, err => {
			console.log(err);
		})
	}

	getNotificationCount() {
		if (!this.userAuthinfo || !this.userAuthinfo['user_id']) return;
		this.http.request('get', '/notification/count-in-app-notification/?user_id=' + this.userAuthinfo['user_id'], null).subscribe(res => {
			if (res && res.data && res.data.length > 0) {
				const countVal = res.data[0].count;
				if (countVal === "no notification found" || countVal === 0 || countVal === "0") {
					this.count = "";
				} else {
					this.count = countVal;
				}
			} else {
				this.count = "";
			}
			this.cdr.detectChanges();
		}, err => {
			console.log(err);
		})
	}


	refreshNotification(flag: any) {
		if (flag) {
			this.http.request('get', '/notification/get-in-app-notification/?user_id=' + this.userAuthinfo['user_id'], null).subscribe(res => {
				let data = res.data.results;
				// let filterData = data.filter(item => item.is_read == false)
				if (data.length > 0) {
					this.count = data[0].pending_count;
					this.cdr.detectChanges();
				}
			})
		}
	}

	// company header dropdown -- start
	companyList = [];

	selectedCompany = 0;
	selectedCompanyName = '';
	selectCompany(event: any, inputType: 'dropdown' | 'search' = 'dropdown', canReload: boolean = true) {
		if (!event) return;

		// 1. Extract values once to avoid repetition
		const companyId = event.id;
		const companyName = event.company_name;

		// 2. Determine if user is a Multi-GC User (Role ID 3)
		const isMultiGcUser = this.userAuthinfo?.role?.id === 3 && this.is_multiple_gc_user;

		// 3. Update State based on Input Type
		if (inputType === 'dropdown') {
			this.selectedCompany = companyId;

			// Efficiently find name from the correct source
			const listToSearch = isMultiGcUser ? this.gc_user_list : this.companyList;
			this.selectedCompanyName = companyName || listToSearch.find(item => item.id === companyId)?.company_name;


		} else {
			this.companySearchText = companyName;
		}

		// 4. Shared Operations (Header & Storage)

		this.companyService.registerModuleCompany('', 0); // Clear active module

		this.companyService.setHeaderCompany(companyId);
		localStorage.setItem('header_gc_id', companyId.toString());
		sessionStorage.setItem('header_gc_id', companyId.toString());

		// 5. Unified Navigation Logic
		this.dashboardSvc.triggerRefresh();
		if (canReload && !isMultiGcUser) {
			this.reloadCurrentRoute();
		}
	}

	/**
	 * Cleanly forces a component refresh by navigating away and back
	 */
	private reloadCurrentRoute() {
		const currentUrl = this.router.url;
		this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
			this.router.navigateByUrl(currentUrl);
		});
	}

	// gcfillist for header dropdown-- start
	getGc(can_reload: any = true) {
		this.http
			.request(
				'get',
				// '/general-contractor/get-gc/?is_active=All&show=All',
				'/general-contractor/get-gc-extender/?is_active=True&show=All',
				null
			)
			.subscribe((res: any) => {

				let data = res; //res.data.results
				let companyList = data.map((item) => {
					return {
						id: item.id,
						company_name: item.company_name,
					};
				});
				// companyList.unshift({ id: 0, company_name: 'Default Company' });
				this.companyList = companyList;

				if (this.userAuthinfo?.role?.id == 3 && this.is_multiple_gc_user) {
					this.filteredCompanyList = this.gc_user_list;
				} else {
					this.filteredCompanyList = companyList;
				}

				// this.GcPagination = res.data;
				// this.gcData = this.GcPagination.results[0];

				const currentCompanyId = this.companyService.getCurrentCompany();
				let selectedCompanyObj: any = null;

				if (this.userAuthinfo?.role?.id == 3 && this.is_multiple_gc_user) {
					selectedCompanyObj = this.gc_user_list.find(item => item.id == currentCompanyId && item.id !== 0);
					if (!selectedCompanyObj && this.gc_user_list.length > 0) {
						selectedCompanyObj = this.gc_user_list[this.gc_user_list.length - 1];
					}
				} else {
					selectedCompanyObj = this.companyList.find(item => item.id == currentCompanyId && item.id !== 0);
					if (!selectedCompanyObj && this.companyList.length > 0) {
						selectedCompanyObj = this.companyList[this.companyList.length - 1];
					}
				}

				if (selectedCompanyObj) {
					this.selectCompany(selectedCompanyObj, 'dropdown', false);
				}
			});


	}

	//   auto complete search -- start
	companySearchText: string = '';
	isLoading = false;

	private searchSubject = new Subject<string>();
	gc_debounce_base() {
		// this.companyControl.valueChanges.pipe(

		// 	debounceTime(400),                 // wait 400ms
		// 	distinctUntilChanged(),            // ignore same value
		// 	tap(() => this.isLoading = true),  // show loader
		// 	switchMap((value: string) => {

		// 		if (!value || value.length < 2) {
		// 			this.isLoading = false;
		// 			return of([]);
		// 		}

		// 		return this.http.request('get', '/general-contractor/get-gc-extender/?is_active=True&show=All', {
		// 			search: value
		// 		});

		// 	})

		// ).subscribe((res: any) => {
		// 	this.companyList = res || [];
		// 	this.isLoading = false;
		// });

		this.searchSubject.pipe(
			debounceTime(400),
			distinctUntilChanged(),
			switchMap((value: string) => {

				if (!value || value.length < 2) {
					return of([]);
				}

				this.isLoading = true;

				return this.http.request('get', `/general-contractor/get-gc-extender/?is_active=True&show=All&company_name=${value}`, null);

			})

		).subscribe((res: any) => {

			this.companyList = res || [];
			this.isLoading = false;

		});
	}

	onCompanySearch(value: string) {
		this.searchSubject.next(value);
	}
	//   auto complete search -- end

	// dropdown searchable -- start

	filteredCompanyList: any[] = [];
	filterCompanies() {
		const search = this.companySearchText?.toLowerCase() || '';

		if (this.userAuthinfo?.role?.id == 3 && this.is_multiple_gc_user) {
			this.filteredCompanyList = this.gc_user_list.filter(company =>
				company.company_name.toLowerCase().includes(search)
			);
		} else {

			this.filteredCompanyList = this.companyList.filter(company =>
				company.company_name.toLowerCase().includes(search)
			);
		}

	}
	// dropdown searchable -- end

	// new enhanced dropdown approach 1 -- start
	@ViewChild('companySearchInput') companySearchInput!: ElementRef;


	onCompanyMenuOpen() {
		setTimeout(() => {
			this.companySearchInput?.nativeElement?.focus();
		}, 100);
	}

	clearSearch(event: Event) {
		event.stopPropagation();
		this.companySearchText = '';
		this.filterCompanies();
	}

	clearCompany() {
		this.selectedCompanyName = null;

		this.companyService.registerModuleCompany('', 0); // Clear active module

		this.companyService.setHeaderCompany(0);
		localStorage.setItem('header_gc_id', '0');
		sessionStorage.setItem('header_gc_id', '0');

		this.dashboardSvc.triggerRefresh();

		this.reloadCurrentRoute();
	}
	// new enhanced dropdown approach 1 -- end

	// gcfillist for header dropdown -- end

	set_gc_id_header(gc_id: any) {

		if (gc_id) {

			this.selectedCompany = gc_id;
			this.selectedCompanyName = this.companyList.find(item => item.id == this.selectedCompany).company_name;

			this.companyService.setHeaderCompany(gc_id);
			localStorage.setItem('header_gc_id', this.selectedCompany.toString());
			sessionStorage.setItem('header_gc_id', this.selectedCompany.toString());
		}
	}

	// company header dropdown -- end

	// multi gc user handling -- start
	is_multiple_gc_user: boolean = false;
	gc_user_list: any[] = [];

	getGcUserList() {

		let gc_users = localStorage.getItem('gc_user_list') ? JSON.parse(localStorage.getItem('gc_user_list')) : [];
		this.gc_user_list = gc_users.map((item) => {
			return {
				id: item.gc_id,
				company_name: item.company_name,
				last_login: item.last_login,
			};
		});
		this.is_multiple_gc_user = this.gc_user_list.length > 1;

		if (this.userAuthinfo?.role?.id == 3 && this.is_multiple_gc_user) {
			this.filteredCompanyList = this.gc_user_list;

			const currentCompanyId = this.companyService.getCurrentCompany();
			let selected = this.gc_user_list.find(item => item.id == currentCompanyId && item.id !== 0);
			if (!selected && this.gc_user_list.length > 0) {
				selected = this.gc_user_list[this.gc_user_list.length - 1];
			}
			if (selected) {
				this.selectCompany(selected, 'dropdown', false);
			}
		}
	}

	show_company_dropdown() {
		if (this.userAuthinfo?.role?.id == 1) {
			return true;
		} else if (this.userAuthinfo?.role?.id == 3 && this.is_multiple_gc_user) {
			return true;
		} else {
			return false;
		}
	}

	switch_gc_for_multi_user(gc_id: any) {

		this.selectedCompany = gc_id;
		this.selectedCompanyName = this.gc_user_list.find(item => item.id == this.selectedCompany)?.company_name;
	}
	decodedToken: any;
	onSwitchUser(event: Event, gc_id: any) {

		if (this.userAuthinfo?.role?.id == 3 && this.is_multiple_gc_user) {

			event.preventDefault();  // <== THIS STOPS THE CANCELLATION
			event.stopPropagation(); // Stops the event from bubbling up

			let payload = { gc_id: gc_id };

			this.http
				.request('post', '/user/switch-user/', payload)
				.subscribe({
					next: (res: any) => {
						if (res) {
							localStorage.setItem('token', res.access);
							localStorage.setItem('header_gc_id', gc_id.toString());
							sessionStorage.setItem('header_gc_id', gc_id.toString());

							this.decodedToken = JSON.stringify(jwt_decode(res.access));
							localStorage.setItem('user_data', this.decodedToken);

							// Now that the data is saved, we can safely refresh or navigate
							window.location.reload();
						}
					},
					error: (err) => console.error("Switch error:", err)
				});
		}

	}

	showCompanySwitcher: boolean = false;

	openCompanySwitcherModal() {
		this.showCompanySwitcher = true;
	}

	handleCompanySelection(company: any) {
		this.showCompanySwitcher = false;
		if (company && company.id) {
			const dummyEvent = new Event('click') as any;
			this.onSwitchUser(dummyEvent, company.id);
		}
	}

	// multi gc user handling -- end
}
